var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRainingFilled = function SvgRainingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 15a5 5 0 1 1 .1-9.999 5.502 5.502 0 0 1 10.195 1.004Q17.395 6 17.5 6a4.5 4.5 0 1 1 0 9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.51 4.02a6.501 6.501 0 0 1 11.502 1.004A5.5 5.5 0 0 1 17.5 16H7a6 6 0 0 1-.49-11.98M12 3a4.5 4.5 0 0 0-4.01 2.456 1 1 0 0 1-.91.545L7 6a4 4 0 1 0 0 8h10.5a3.5 3.5 0 1 0-.16-6.996 1 1 0 0 1-1.008-.728A4.5 4.5 0 0 0 12 3M8.371 17.572a1 1 0 0 1 .557 1.3l-1 2.5a1 1 0 1 1-1.856-.743l1-2.5a1 1 0 0 1 1.3-.558m4 0a1 1 0 0 1 .557 1.3l-1 2.5a1 1 0 0 1-1.857-.743l1-2.5a1 1 0 0 1 1.3-.558m4 0a1 1 0 0 1 .558 1.3l-1 2.5a1 1 0 0 1-1.857-.743l1-2.5a1 1 0 0 1 1.3-.558",
    clipRule: "evenodd"
  })));
};
export default SvgRainingFilled;